export default __webpack_public_path__ + "static/media/Bitmap.97b028b1.png";